// extracted by mini-css-extract-plugin
module.exports = {"loginCotnent":"LoginContent_loginCotnent__13Nw3","loginBox":"LoginContent_loginBox__1yNAs"};